// Consenso privacy dei moduli di contatto (#708).
//
// La spunta rende il testo da PRIVACY_CONSENT_PARTS (la parte centrale è il
// link all'informativa), e il documento salva PRIVACY_CONSENT_TEXT, che è la
// concatenazione delle stesse parti: il testo registrato è per costruzione
// quello che il visitatore ha visto. Se cambi il testo o l'informativa, alza
// PRIVACY_CONSENT_VERSION.
//
// Forma salvata su wpformsSubmissions / leads (letta da newarc-platform,
// lib/classes/privacy_consent.dart):
//   privacyConsent: { accepted, acceptedAt, text, policyUrl, version }
//
// Stessa forma, dal #723, anche su:
//   - renovationQuotation (AddRenovationQuote.vue), accanto a `privacy`, che
//     resta il record della firma DocuSign della piattaforma;
//   - videocallRequests (BookVideocallPopup.vue): la regola Firestore ammette
//     in privacyConsent esattamente queste cinque chiavi;
//   - additionalInfo del POST a /predict (Configure.vue), accanto al booleano
//     privacyCheckbox;
//   - payload della callable contactFormEmailSend (ValuationStep.vue), che per
//     ora non lo salva.

// Versione 2 (#815): fino alla 1 il link portava all'informativa iubenda di
// newarc.it (il sito WordPress di Newarc, con trattamenti diversi) e il testo
// diceva "Ho letto e accetto": l'informativa non si accetta, se ne prende
// visione (art. 13 GDPR). Ora il link è l'informativa di immaginacasa.com e la
// versione segue quella del documento (PRIVACY_VERSION in legalDocuments.js).
import { PRIVACY_VERSION, legalUrl } from "./legalDocuments.js";

// Anche il flusso Configure (AdditionalInfoStep.vue) linka questa.
export const PRIVACY_POLICY_URL = legalUrl("privacy");
export const PRIVACY_CONSENT_VERSION = PRIVACY_VERSION;

export const PRIVACY_CONSENT_PARTS = Object.freeze({
  before: "Ho letto l'",
  link: "informativa sulla privacy",
  after: ".",
});

export const PRIVACY_CONSENT_TEXT =
  PRIVACY_CONSENT_PARTS.before + PRIVACY_CONSENT_PARTS.link + PRIVACY_CONSENT_PARTS.after;

// Oggetto da salvare nel documento, al momento dell'invio del modulo.
export function buildPrivacyConsent(now = Date.now()) {
  return {
    accepted: true,
    acceptedAt: now,
    text: PRIVACY_CONSENT_TEXT,
    policyUrl: PRIVACY_POLICY_URL,
    version: PRIVACY_CONSENT_VERSION,
  };
}

// Guardia dei servizi: niente documento di contatto senza un consenso valido.
export function isPrivacyConsent(c) {
  return (
    !!c &&
    c.accepted === true &&
    Number.isInteger(c.acceptedAt) &&
    typeof c.text === "string" &&
    c.text !== "" &&
    typeof c.policyUrl === "string" &&
    c.policyUrl !== "" &&
    Number.isInteger(c.version)
  );
}
